export const CHANGE_NAME = 'CHANGE_NAME';

export function changeName(value){
    return {type: CHANGE_NAME, payload: value};
}